module.exports = __webpack_public_path__ + "img/security-500.13679fb9.gif";